// import axiosInstance from "../common/axios/axsiosInstance";
// export function getAccessToken() {
//   const data = localStorage.getItem("accessToken");
//   const response = data;
//   return response;
// }
// const token = getAccessToken();
// class FileUploadService {
//   // Your backend API base URL
//   static API_BASE_URL = `forge/upload`;

//   /**
//    * Upload file to your backend API instead of directly to Forge
//    */
//   static async uploadFile(file, accessToken, onProgress = null) {
//     try {
//       // Create FormData for file upload
//       const formData = new FormData();
//       formData.append("file", file);

//       // Upload configuration
//       const config = {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       };

//       // Add progress tracking if provided
//       if (onProgress) {
//         config.onUploadProgress = (progressEvent) => {
//           const percentCompleted = Math.round(
//             (progressEvent.loaded * 100) / progressEvent.total
//           );
//           onProgress(percentCompleted);
//         };
//       }

//       // Upload to your backend
//       const response = await axiosInstance.post(
//         `forge/upload`,
//         formData,
//         config
//       );

//       // Your backend should return the processed data
//       return {
//         urn: response.data.urn,
//         objectId: response.data.objectId,
//         jobId: response.data.jobId,
//         fileName: file.name,
//         uploadId: response.data.uploadId, // Backend generated ID
//         status: response.data.status || "processing",
//       };
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || error.message;
//       throw new Error(`Upload failed: ${errorMessage}`);
//     }
//   }

//   /**
//    * Get translation status from your backend
//   //  */
//   // static async getTranslationStatus(urn, accessToken) {
//   //   try {
//   //     const response = await axios.get(
//   //       `${this.API_BASE_URL}/forge/status/${urn}`,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${accessToken}`,
//   //         },
//   //       }
//   //     );

//   //     return response.data;
//   //   } catch (error) {
//   //     const errorMessage = error.response?.data?.message || error.message;
//   //     throw new Error(`Failed to get translation status: ${errorMessage}`);
//   //   }
//   // }

//   /**
//    * Get list of uploaded files from your backend
//    */
//   static async getUserFiles(accessToken) {
//     try {
//       const response = await axiosInstance.get(`${this.API_BASE_URL}/forge/files`);

//       return response.data;
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || error.message;
//       throw new Error(`Failed to get user files: ${errorMessage}`);
//     }
//   }

//   /**
//    * Delete file from your backend
//    */
//   static async deleteFile(fileId, accessToken) {
//     try {
//       const response = await axiosInstance.delete(
//         `${this.API_BASE_URL}/forge/files/${fileId}`
//       );

//       return response.data;
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || error.message;
//       throw new Error(`Failed to delete file: ${errorMessage}`);
//     }
//   }

//   /**
//    * Get file details from your backend
//    */
//   static async getFileDetails(fileId, accessToken) {
//     try {
//       const response = await axiosInstance.get(
//         `${this.API_BASE_URL}/forge/files/${fileId}`
//       );

//       return response.data;
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || error.message;
//       throw new Error(`Failed to get file details: ${errorMessage}`);
//     }
//   }

//   /**
//    * Check if file format is supported
//    */
//   static isSupportedFormat(filename) {
//     const supportedExtensions = [
//       ".dwg",
//       ".dwf",
//       ".dwfx",
//       ".ifc",
//       ".rvt",
//       ".nwd",
//       ".nwc",
//       ".3ds",
//       ".fbx",
//       ".obj",
//       ".step",
//       ".stp",
//       ".iges",
//       ".igs",
//       ".sat",
//       ".sab",
//       ".skp",
//       ".3dm",
//       ".stl",
//       ".ipt",
//       ".iam",
//       ".f3d",
//       ".f3z",
//       ".pdf",
//     ];

//     const extension = "." + filename.split(".").pop().toLowerCase();
//     return supportedExtensions.includes(extension);
//   }

//   /**
//    * Validate file before upload
//    */
//   static validateFile(file) {
//     const maxSize = 100 * 1024 * 1024; // 100MB
//     const errors = [];

//     if (!file) {
//       errors.push("No file selected");
//     } else {
//       if (!this.isSupportedFormat(file.name)) {
//         errors.push(`Unsupported file format: ${file.name.split(".").pop()}`);
//       }

//       if (file.size > maxSize) {
//         errors.push("File size exceeds 100MB limit");
//       }

//       if (file.size === 0) {
//         errors.push("File is empty");
//       }
//     }

//     return {
//       isValid: errors.length === 0,
//       errors: errors,
//     };
//   }
// }

// export default FileUploadService;
import axiosInstance from "../common/axios/axsiosInstance";

export function getAccessToken() {
  const data = localStorage.getItem("accessToken");
  const response = data;
  return response;
}
const token = getAccessToken();

class FileUploadService {
  // Your backend API base URL
  static API_BASE_URL = `forge/upload`;

  /**
   * Upload file to your backend API instead of directly to Forge
   *
   * ==== ԾԱՆՈԹԱԳՐՈՒԹՅՈՒՆ (upload progress ուղղում) ====
   * Իրական browser->server byte-transfer-ը (onUploadProgress) սովորաբար ավարտվում է
   * շատ արագ, բայց backend-ը դրանից հետո կարող է երկար ժամանակ մշակել ֆայլը
   * (Forge translation/processing), որի ընթացքում axios-ը ոչինչ չի կանչում,
   * քանի որ bytes-երն արդեն ուղարկված են։ Դրա համար.
   *  1) Իրական transfer progress-ը սահմանափակում ենք առավելագույնը 90%-ով։
   *  2) Երբ transfer-ը հասնում է 100%-ի (bytes ուղարկված են, բայց backend-ը
   *     դեռ մշակում է), սկսում ենք մի «trickle» timer, որը դանդաղ բարձրացնում է
   *     progress-ը մինչև 98%, որպեսզի օգտատերը տեսնի, որ ինչ-որ բան կատարվում է։
   *  3) Backend-ի response-ը ստանալուն պես՝ progress-ը դրվում է 100%։
   *  4) Պաշտպանվում ենք progressEvent.total undefined/0 լինելուց (NaN-ից)։
   */
  static async uploadFile(file, accessToken, onProgress = null) {
    let trickleTimer = null;
    let lastReported = 0;

    const reportProgress = (percent) => {
      const clamped = Math.max(0, Math.min(100, Math.round(percent)));
      if (clamped > lastReported || clamped === 100) {
        lastReported = clamped;
        onProgress?.(clamped);
      }
    };

    const startTrickle = () => {
      if (trickleTimer) return;
      trickleTimer = setInterval(() => {
        if (lastReported < 98) {
          reportProgress(lastReported + 1);
        }
      }, 400);
    };

    const stopTrickle = () => {
      if (trickleTimer) {
        clearInterval(trickleTimer);
        trickleTimer = null;
      }
    };

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("file", file);

      // Upload configuration
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Add progress tracking if provided
      if (onProgress) {
        config.onUploadProgress = (progressEvent) => {
          // Պաշտպանվում ենք NaN-ից, երբ total-ը հայտնի չէ (chunked/unknown length)
          if (!progressEvent.total) {
            if (lastReported === 0) reportProgress(1);
            return;
          }

          const percentCompleted =
            (progressEvent.loaded * 100) / progressEvent.total;

          // Իրական transfer progress-ը սահմանափակում ենք 90%-ով,
          // մնացած 10%-ը թողնում ենք server-side processing-ի trickle-ի համար
          const capped = Math.min(percentCompleted, 90);
          reportProgress(capped);

          // Bytes-երն ամբողջությամբ ուղարկված են, բայց backend-ը դեռ մշակում է
          if (progressEvent.loaded >= progressEvent.total) {
            startTrickle();
          }
        };
      }

      // Upload to your backend
      const response = await axiosInstance.post(
        `forge/upload`,
        formData,
        config,
      );

      stopTrickle();
      reportProgress(100);

      // Your backend should return the processed data
      return {
        urn: response.data.urn,
        objectId: response.data.objectId,
        jobId: response.data.jobId,
        fileName: file.name,
        uploadId: response.data.uploadId, // Backend generated ID
        status: response.data.status || "processing",
        urnId: response.data.urn_id,
        conversion_status: response.data.conversion_status,
      };
    } catch (error) {
      stopTrickle();
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Upload failed: ${errorMessage}`);
    }
  }

  /**
   * Get list of uploaded files from your backend
   */
  static async getUserFiles(accessToken) {
    try {
      const response = await axiosInstance.get(
        `${this.API_BASE_URL}/forge/files`,
      );

      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Failed to get user files: ${errorMessage}`);
    }
  }

  /**
   * Delete file from your backend
   */
  static async deleteFile(fileId, accessToken) {
    try {
      const response = await axiosInstance.delete(
        `${this.API_BASE_URL}/forge/files/${fileId}`,
      );

      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Failed to delete file: ${errorMessage}`);
    }
  }

  /**
   * Get file details from your backend
   */
  static async getFileDetails(fileId, accessToken) {
    try {
      const response = await axiosInstance.get(
        `${this.API_BASE_URL}/forge/files/${fileId}`,
      );

      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Failed to get file details: ${errorMessage}`);
    }
  }

  /**
   * Check if file format is supported
   */
  static isSupportedFormat(filename) {
    const supportedExtensions = [
      ".dwg",
      ".dwf",
      ".dwfx",
      ".ifc",
      ".rvt",
      ".nwd",
      ".nwc",
      ".3ds",
      ".fbx",
      ".obj",
      ".step",
      ".stp",
      ".iges",
      ".igs",
      ".sat",
      ".sab",
      ".skp",
      ".3dm",
      ".stl",
      ".ipt",
      ".iam",
      ".f3d",
      ".f3z",
      ".pdf",
    ];

    const extension = "." + filename.split(".").pop().toLowerCase();
    return supportedExtensions.includes(extension);
  }

  /**
   * Validate file before upload
   */
  static validateFile(file) {
    const maxSize = 100 * 1024 * 1024; // 100MB
    const errors = [];

    if (!file) {
      errors.push("No file selected");
    } else {
      if (!this.isSupportedFormat(file.name)) {
        errors.push(`Unsupported file format: ${file.name.split(".").pop()}`);
      }

      if (file.size > maxSize) {
        errors.push("File size exceeds 100MB limit");
      }

      if (file.size === 0) {
        errors.push("File is empty");
      }
    }

    return {
      isValid: errors.length === 0,
      errors: errors,
    };
  }
}

export default FileUploadService;
